import { useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../selectors/getOnsaCurrentProductSelector';
import { useAsyncThrow } from '../../hooks/useAsyncThrow';
import { isLoggedOnSelector } from '../selectors/isLoggedOnSelector';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export function useAddOrRemoveCoverage(): {
    addOrRemoveCoverage: (coverageId: string, packageGroupName: string) => Promise<void>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const { fixedId, lobCode } = useRecoilValue(getOnsaCurrentProductSelector);
    const { asyncThrow } = useAsyncThrow();

    if (!jobNumber) throw new Error('Invalid jobNumber');
    if (!sessionId) throw new Error('Invalid sessionId');
    if (!lobCode) throw new Error('Invalid lobCode');
    if (!fixedId) throw new Error('Invalid coverableFixedId');
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const addOrRemoveCoverage = async (
        coverageId: string,
        packageGroupName: string
    ): Promise<void> => {
        await OnlineSalesUnauthenticated.addOrRemoveCoverage(
            jobNumber,
            lobCode,
            fixedId,
            coverageId,
            packageGroupName,
            sessionId,
            !isLoggedOn
        ).catch(asyncThrow);
    };

    return { addOrRemoveCoverage };
}
